import { styled } from 'styled-components';

import { Media } from '../../../index.ts';

const MetaContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 2px;
  padding: 12px;
  ${({ theme }) => theme.typography.textMedium}
  ${({ theme }) => theme.typography.weightMedium}
`;

const MetaHeader = styled.div`
  ${({ theme }) => theme.typography.textMedium}
  color: ${({ theme }) => theme.colors.grey100_1};
`;

const MetaFooter = styled.div`
  ${({ theme }) => theme.typography.textSmall}
`;

const List = styled.div`
  ${({ theme }) => theme.shadows.small}
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.grey00_1};
  display: flex;
  flex-flow: column nowrap;
  margin: auto;
  min-width: 150px;
  & > *:not(last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey01_1};
  }

  @media ${Media.smMax} {
    flex-direction: row;
    justify-content: space-between;
    & > *:not(last-child) {
      border-right: 1px solid ${({ theme }) => theme.colors.grey01_1};
    }
  }
`;

export type Meta = {
  header?: string;
  content: string;
  footer?: string;
};

// A.k.a AutorInfo
export const MetaUnit = ({ header, content, footer }: Meta) => (
  <MetaContainer>
    {header && <MetaHeader>{header}</MetaHeader>}
    {content}
    {footer && <MetaFooter>{footer}</MetaFooter>}
  </MetaContainer>
);

export const MetaList = ({ meta }: { meta: Meta[] }) => (
  <List>
    {meta.map((m) => (
      <MetaUnit key={m.content} {...m} />
    ))}
  </List>
);
